module.exports = __webpack_public_path__ + "img/clear.249904c5.svg";